import { render, staticRenderFns } from "./ShippedByFNS-Column-City.vue?vue&type=template&id=6b58886f&"
import script from "./ShippedByFNS-Column-City.vue?vue&type=script&lang=js&"
export * from "./ShippedByFNS-Column-City.vue?vue&type=script&lang=js&"
import style0 from "./ShippedByFNS-Column-City.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports